<script>
import Layout from "../../layouts/main";
import ChargerReport from "./charger-report.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "user-details",
  data() {
    return {};
  },
  components: {
    Layout,
    ChargerReport,
  },
  computed: mapGetters([]),
  methods: {
    ...mapActions([]),
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left d-flex align-items-center">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-tag"></i>
              </span>
            </div>
            <h4 class="mb-0 font-size-18">Reports</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <ChargerReport />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.page-title-box {
  padding-bottom: 24px;
}
.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}
.page-title-box h4 {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px !important;
}
.icon-main-page .page-title-left {
  display: flex;
  align-items: center;
}
.avatar-main-icon .avatar-xs {
  margin-top: -20px;
}
</style>
